import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFormAction } from "../../Actions/FormAction/FormAction";
import { getVisitAction } from "../../Actions/VisitAction/VisitAction";
import LoadingPage from "../../Pages/Loading/LoadingPage";

const ViewAllInfoModal = ({ closeModal, patientId }) => {
  const dispatch = useDispatch();
  const [state, setState] = useState({});
  const getForm = useSelector((state) => state.getForm);
  const { forms } = getForm;
  const [visit, setVisit] = useState([]);
  const [doctorId, setDoctorId] = useState([]);
  const [diseas, setDiseas] = useState([]);
  const [organ, setOrgan] = useState([]);
  const [organLevel, setOrganLevel] = useState([]);
  const [TYP, setTYP] = useState([]);

  const handleSelectVisit = (visit) => {
    setDoctorId([]);
    setOrgan([]);
    setDiseas([]);
    setTYP([]);
    setOrganLevel([]);
    if (visit == -1) {
      setVisit([]);
      return;
    } else {
      setVisit(visit);
    }
  };
  useEffect(() => {
    dispatch(getFormAction([1, 2]));
    dispatch(getVisitAction(patientId));
  }, [patientId]);

  const getVisit = useSelector((state) => state.getVisit);
  const { visits, loading } = getVisit;
  useEffect(() => {
    setDoctorId([{}]);
    if (visit.length <= 0) {
      return;
    }
    let tempInputValue = {};
    visit?.affiars_of_surgery?.map((affiars) => {
      if (affiars.note == null || affiars.note == undefined) {
        tempInputValue[affiars.type] = null;
      } else {
        tempInputValue[affiars.type] = affiars.note;
      }
    });

    visit?.follow_up_commite?.map((follow) => {
      let tempDoctor = [];
      if (follow.doctor) {
        follow?.doctor?.map((dr) => {
          tempDoctor.push(dr);
        });
        setDoctorId([...doctorId, tempDoctor]);
      }

      let tempOrgan = [];
      if (follow.organ) {
        follow?.organ?.map((organ) => {
          tempOrgan.push(organ);
        });
        setOrgan([...organ, tempOrgan]);
      }

      let tempOrganLevel = [];
      if (follow.organ_level) {
        follow?.organ_level?.map((organ_level) => {
          tempOrganLevel.push(organ_level);
        });
        setOrganLevel([...organLevel, tempOrganLevel]);
      }

      let tempDiseas = [];
      if (follow.disease_type_specialist) {
        follow?.disease_type_specialist?.map((disease_type_specialist) => {
          tempDiseas.push(disease_type_specialist);
        });
        setDiseas([...diseas, tempDiseas]);
      }

      let tempTYP = [];
      if (follow.TYP) {
        follow?.TYP?.map((TYP) => {
          tempTYP.push(TYP);
        });
        setTYP([...TYP, tempTYP]);
      }

      if (follow.note == null || follow.note == undefined) {
        tempInputValue[follow.type] = null;
      } else {
        tempInputValue[follow.type] = follow.note;
      }
    });
    setState({ ...tempInputValue });
  }, [visit]);

  return (
    <React.Fragment>
      {loading ? (
        "loading"
      ) : (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg shadow-lg w-full md:w-11/12 h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center border-b p-4">
              <h3 className="text-2xl font-semibold text-gray-800">
                Patient Information
              </h3>
              <button
                onClick={closeModal}
                className="text-red-500 hover:text-red-700"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <div className="p-6">
              <div className="mb-4">
                <select
                  name=""
                  onChange={(e) =>
                    handleSelectVisit(JSON.parse(e.target.value))
                  }
                  className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                  id=""
                >
                  <option value="-1">Select Visit</option>
                  {visits?.map((visit, index) => (
                    <option key={index} value={JSON.stringify(visit)}>
                      {visit?.created_at?.split("T")[0]}
                    </option>
                  ))}
                </select>
              </div>

              {organ.length > 0 ? (
                <form className="space-y-6">
                  {forms?.map((form, formIndex) => (
                    <div key={formIndex}>
                      {form.sectionForm.map((section, sectionIndex) => (
                        <div key={sectionIndex}>
                          <div className="bg-blue-500 text-white text-center rounded-md py-2 my-4">
                            {section.title}
                          </div>
                          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
                            {section.field.map((field, index) => (
                              <div key={index} className="flex flex-col">
                                <label className="text-gray-700 font-medium mb-1">
                                  {field.label} *
                                </label>
                                {field.type === "textarea" ? (
                                  <textarea
                                    name={field.name}
                                    value={state[field.name] || ""}
                                    placeholder={field.placeholder}
                                    className="p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                  />
                                ) : field.type === "dropdown" ? (
                                  <select
                                    name={field.name}
                                    value={state[field.name] || ""}
                                    className="p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                  >
                                    <option value="">
                                      Please select an option
                                    </option>
                                    {field.drop_down.map((dropdown, index) => (
                                      <option
                                        key={index}
                                        value={dropdown.value}
                                      >
                                        {dropdown.value}
                                      </option>
                                    ))}
                                  </select>
                                ) : (
                                  <input
                                    type={field.type}
                                    name={field.name}
                                    value={state[field.name] || ""}
                                    placeholder={field.placeholder}
                                    className="p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                  />
                                )}
                              </div>
                            ))}
                          </div>
                          <hr className="my-6" />
                        </div>
                      ))}
                    </div>
                  ))}
                  <div className="grid grid-cols-2 gap-4">
                    <div className="flex flex-col">
                      <label className="text-gray-700 font-medium mb-1">
                        Doctor *
                      </label>
                      <input
                        type="text"
                        className="p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={doctorId.join(", ")}
                        readOnly
                      />
                    </div>
                    <div className="flex flex-col">
                      <label className="text-gray-700 font-medium mb-1">
                        Disease Type Specialist *
                      </label>
                      <input
                        type="text"
                        className="p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={diseas.join(", ")}
                        readOnly
                      />
                    </div>
                    <div className="flex flex-col">
                      <label className="text-gray-700 font-medium mb-1">
                        Organ *
                      </label>
                      <input
                        type="text"
                        className="p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={organ.join(", ")}
                        readOnly
                      />
                    </div>
                    <div className="flex flex-col">
                      <label className="text-gray-700 font-medium mb-1">
                        TYP *
                      </label>
                      <input
                        type="text"
                        className="p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={TYP.join(", ")}
                        readOnly
                      />
                    </div>
                    <div className="flex flex-col">
                      <label className="text-gray-700 font-medium mb-1">
                        Organ Level *
                      </label>
                      <input
                        type="text"
                        className="p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={organLevel.join(", ")}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mt-8">
                    {visits?.map((visit, index) =>
                      visit?.patient?.patient_cv?.map((cv, Cvindex) => (
                        <a
                          key={index + Cvindex}
                          // src={}
                          href={`${process.env.REACT_APP_IMAGE_API_URL}${cv.path}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            className="h-48 w-full rounded-md shadow-lg"
                            src={`${process.env.REACT_APP_IMAGE_API_URL}${cv.path}`}
                            alt="Patient CV"
                          />
                        </a>
                      ))
                    )}
                  </div>
                </form>
              ) : (
                <LoadingPage />
              )}
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default ViewAllInfoModal;
